import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { BLANK_VALUE } from "./constants";
import "dayjs/locale/en-in"

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("en-in");
dayjs.tz.setDefault('Asia/Kolkata');

export const formatDate = (date) => {
  return date ? dayjs(date).format("DD-MM-YYYY") : null;
};

export const formatDateToDayJS = (date) => {
  return date ? dayjs(date).tz("Asia/Kolkata").add(3, 'hours') : null;
};

export function replaceNull(jsonObject, replaceValue = BLANK_VALUE) {
  const replacedObject = (key, value) =>
    String(value) === "null" || String(value) === "undefined" || value === ""
      ? replaceValue
      : value;
  return JSON.parse(JSON.stringify(jsonObject, replacedObject));
}

export function replaceBlankValueToUndefined(jsonObject) {
  const replacedObject = (key, value) => (isEmpty(value) ? undefined : value);
  return JSON.parse(JSON.stringify(jsonObject, replacedObject));
}

export function replaceUndefinedToNull(jsonObject, replaceValue = null) {
  const replacedObject = (key, value) =>
    String(value) === "undefined" ? replaceValue : value;
  return JSON.parse(JSON.stringify(jsonObject, replacedObject));
}

export const displayFormattedDate = (date) => {
  return date ? dayjs(date).format("DD-MM-YYYY") : null;
};

export const setDataToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getDataFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const getClientConfig = () => {
  return JSON.parse(localStorage.getItem("clientConfig"));
};

export const getFilterValues = (columnKey, records) => {
  if (records && records != BLANK_VALUE) {
    let filterOptions = [];
    //records.sort((a, b) => a[columnKey].localeCompare(b[columnKey]));
    const options = [...new Set(records.map((record) => record[columnKey]))];
    filterOptions = options.map((option) => {
      return { value: option, text: option };
    });
    return filterOptions;
  }
};

export const isEmpty = (value) => {
  if (value === null || value === undefined || value === BLANK_VALUE || value === "") {
    return true;
  }
  return false;
};

export const getCreditors = (accounts) => {
  // const creditors = accounts.filter((account) => account.accountType === "C");
  // return creditors;
  return accounts;
};

export const getDebtors = (accounts) => {
  // const debtors = accounts.filter((account) => account.accountType === "D");
  // return debtors;
  return accounts;
};

export const getBanks = (accounts) => {
  const banks = accounts.filter((account) => account.accountType === "B");
  return banks;
};

export const getAccountHolderName = (accountId) => {
  const { account } = getClientConfig();
  const accountName = account?.find((account) => account.id === accountId)?.accountName;
  return accountName;
};

export const getTrueOrFalseFromZeroAndOne = (value) => {
  if (value) {
    return true;
  } else {
    return false;
  }
};

export const convertAmountToWords = (number) => {
  let oneToTwenty = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ',
    'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
  let tenth = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if ((number = number.toString()).length > 9) return 'overflow';
  let n = ('000000000' + number).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return; var str = '';
  str += (n[1] != 0) ? (oneToTwenty[Number(n[1])] || tenth[n[1][0]] + ' ' + oneToTwenty[n[1][1]]) + 'Crore ' : '';
  str += (n[2] != 0) ? (oneToTwenty[Number(n[2])] || tenth[n[2][0]] + ' ' + oneToTwenty[n[2][1]]) + 'Lakh ' : '';
  str += (n[3] != 0) ? (oneToTwenty[Number(n[3])] || tenth[n[3][0]] + ' ' + oneToTwenty[n[3][1]]) + 'Thousand ' : '';
  str += (n[4] != 0) ? (oneToTwenty[Number(n[4])] || tenth[n[4][0]] + ' ' + oneToTwenty[n[4][1]]) + 'Hundred ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (oneToTwenty[Number(n[5])] || tenth[n[5][0]] + ' ' + oneToTwenty[n[5][1]]) : '';
  return str;

}

export const formatCurrency = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    // console.log(e)
  }
};